export default "__VITE_ASSET__C$EH40_F__"